<div *ngIf="reserveSpace() ? true : loading()"
     [style.visibility]="loading() ? 'visible' : 'hidden'"
     class="progress-linear"
     role="progressbar">
  <div class="container">
    <div class="bar"></div>
  </div>
</div>
